import {
  BaseEngine,
  BaseModule,
  BaseSystem,
  ENGINE_TOKEN,
  organizeSystemOperations,
  SYSTEMS_TOKEN,
} from './injectable';

export class CoreModule implements BaseModule {
  static readonly INJECTABLE_TOKEN = Symbol.for('CoreModule');

  readonly api = {};

  constructor({
    [ENGINE_TOKEN]: engine,
    [SYSTEMS_TOKEN]: systems,
  }: {
    [ENGINE_TOKEN]: BaseEngine;
    [SYSTEMS_TOKEN]: BaseSystem[];
  }) {
    const systemOperations = organizeSystemOperations(systems);
    engine.registerSystemOperations(systemOperations);
  }
}
